import Head from 'next/head';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import removeHTML from 'site-react/core/helpers/removeHTML';
import PageBanner, {
  WorkplaceStrategyBanner,
} from 'site-react/features/PageBanner';

import Navigation from 'site-react/features/Navigation';
import Footer from 'site-react/core/Footer';

import Meta from '../../components/Meta';
import defaultMeta from '../../content/meta/default';

const PageLayout = ({
  children,
  isPageBannerHidden,
  isFooterHidden,
  isNavigationHidden,
  meta,
  router,
}) => (
  <>
    <Head>
      <title>
        {removeHTML(meta.title) || defaultMeta.title}
        {removeHTML(meta.titleSuffix) || defaultMeta.titleSuffix}
      </title>
    </Head>
    <Meta router={router} {...meta} />
    {isPageBannerHidden ? null : (
      <PageBanner>
        <WorkplaceStrategyBanner />
      </PageBanner>
    )}
    {isNavigationHidden ? null : <Navigation currentPage="ssr" />}

    {children}

    {isFooterHidden ? null : <Footer />}
  </>
);

PageLayout.defaultProps = {
  children: null,
  navbarIsOpaque: true,
  isPageBannerHidden: false,
  isFooterHidden: false,
  isNavigationHidden: false,
  meta: {
    title: defaultMeta.title,
    titleSuffix: defaultMeta.titleSuffix,
  },
  router: {},
};

PageLayout.propTypes = {
  children: PropTypes.node,
  navbarIsOpaque: PropTypes.bool,
  isPageBannerHidden: PropTypes.bool,
  isFooterHidden: PropTypes.bool,
  isNavigationHidden: PropTypes.bool,
  meta: PropTypes.shape({
    title: PropTypes.string,
    titleSuffix: PropTypes.string,
  }),
  router: PropTypes.shape({}),
};

export default withRouter(PageLayout);
export { PageLayout as PageLayoutWithoutRouter };
